const Footer = () => {
  return (
    <footer style={styles.footer}>
      <p style={styles.footerText}>
        © 2025 navyamalhotra &nbsp;|&nbsp; Made with ❤️ 
      </p>
    </footer>
  );
};

const styles = {
  footer: {
    padding: '20px 0',
    textAlign: 'center',
    backgroundColor: 'transparent', // let the page background show through
    color: '#ffb86b',
    fontSize: '1rem',
    fontWeight: '500',
    userSelect: 'none',
    borderTop:'1px solid #ffbd59'
  },
  footerText: {
    margin: 0,
  },
};

export default Footer;
